// ======================================================================
// File Name       : AdaptiveAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as courseRequests from './httpRequests/course';
import * as adaptiveRequests from './httpRequests/adaptive';
import * as adaptiveActionCreators from './actionCreators/adaptive/adaptive';
import { SELECT_TARGET_DATA, STRUCTURE_LEVEL, MESSAGE_TYPE } from '../constants';
import { SHOW_MESSAGE } from '../constants/actionTypes/message';
import * as MessageTemplate from '../constants/MessageTemplate';

export function getCourseList() {
  return async (dispatch) => {
    const courseList = await courseRequests.postCourseGetList({ selectTargetData: 0 });
    return dispatch(
      adaptiveActionCreators.discriminationDegreeData(
        courseList,
      ),
    );
  };
}


export function getAdaptiveMetaImportList(params) {
  return async (dispatch, getState) => {
    let recordNum = 0;
    let importResultList = [];
    const importResultRes = await adaptiveRequests.getAdaptiveMetaImportList(params);
    if (
      importResultRes &&
      importResultRes.importResultList &&
      importResultRes.importResultList.length
    ) {
      recordNum = importResultRes.recordNum;
      importResultList = importResultRes.importResultList;
    }
    return dispatch(
      adaptiveActionCreators.receivedAdaptiveMetaImportList(recordNum, importResultList),
    );
  };
}

export function importAdaptiveMeta(params, resultParam) {
  return async (dispatch, getState) => {
    await adaptiveRequests.importAdaptiveMeta(params);
    return null;
  };
}

export function exportAdaptiveMeta(params) {
  return async (dispatch, getState) => {
    await adaptiveRequests.exportAdaptiveMeta(params);
    return null;
  };
}

export function exportCourse() {
  return async (dispatch, getState) => {
    await adaptiveRequests.exportCourse();
    return null;
  };
}

export function collectiveReflection(params) {
  return async (dispatch, getState) => {
    // #6829 START
    await adaptiveRequests.collectiveReflection(params);
    dispatch(showMessage(MessageTemplate.ADAPTIVE_DISCRIMINATION_DEGREE_DATA));
    return null;
    // #6829 END
  };
}

function showMessage(message) {
  return (dispatch) => {
    const messageInfo = {
      message: [message],
    };
    messageInfo.messageType = MESSAGE_TYPE.success;
    dispatch({ type: SHOW_MESSAGE, ...messageInfo });
  };
}
